import { z } from 'zod'
import { Model } from '../../_kernel/architecture'

export const LikeBelongValidation = z.object({
  value: z.boolean({ required_error: 'value is required' }),
})

export class LikeBelong extends Model {
  static create({ value }: z.infer<typeof LikeBelongValidation>) {
    LikeBelongValidation.parse({ value })
    return new LikeBelong(value)
  }

  constructor(private readonly _value: boolean) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  isLiked() {
    return this.value
  }

  toJSON() {
    return { value: this.value }
  }
}
